import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const fetchClientServiceDetails = createAsyncThunk(
    'clients/fetchClientServiceDetails',
    async (id, { rejectWithValue }) => {
        try {
            const res = await axios.get(`${BACKEND_URL}/provider/get-service-details/${id}`);
            return res.data;
        } catch (error) {
            return rejectWithValue('Failed to fetch provider details');
        }
    }
);

export const clientServiceAddFavourites = createAsyncThunk(
  "client/add-service-favorite",
  async ({ service_id }, thunkAPI) => {
    try {
      const token = localStorage.getItem("client_access_token");

      const res = await axios.post(
        `${BACKEND_URL}/provider/add-service-favorite/${service_id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Add favourites failed"
      );
    }
  }
);

export const clientServiceRemoveFavourites = createAsyncThunk(
  "client/remove-service-favorite",
  async ({ service_id }, thunkAPI) => {
    try {
      const token = localStorage.getItem("client_access_token");

      const res = await axios.post(
        `${BACKEND_URL}/provider/remove-service-favorite/${service_id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Remove favourites failed"
      );
    }
  }
);

const clientServiceDetailsSlie = createSlice({
    name: 'clientServiceDetails',
    initialState: {
        loading: false,
        error: null,
        clientServiceDetails: null,
        pagination: {},
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchClientServiceDetails.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(fetchClientServiceDetails.fulfilled, (state, action) => {
            state.loading = false;
            state.clientServiceDetails = action.payload;
        })
        .addCase(fetchClientServiceDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || 'Failed to fetch details data'
        });
    }
})

export default clientServiceDetailsSlie.reducer;